import { Component, Inject, OnInit, PLATFORM_ID } from '@angular/core';
import { CommonModule, isPlatformBrowser } from '@angular/common';
import { RouterModule, ActivatedRoute, Router } from '@angular/router';
import {
  IconHome,
  IconLayout2,
  IconKey,
  IconUsers,
  IconBuilding,
  IconBook2,
  IconAppWindow,
  IconFileDiff
} from 'angular-tabler-icons/icons';
import { TablerIconComponent,provideTablerIcons } from 'angular-tabler-icons';
import { ConfirmationService, MenuItem } from 'primeng/api';
import { AvatarModule } from 'primeng/avatar';
import { BadgeModule } from 'primeng/badge';
import { ButtonModule } from 'primeng/button';
import { PanelMenuModule } from 'primeng/panelmenu';
import { TooltipModule } from 'primeng/tooltip';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { SIDE_MENU_CONSTANTS } from './sidemenu-constants';
import { SidebarService } from '../../services/sidebar.service';
import { KeycloakService } from 'usermgmt';
import { AppStateService, PROJECT_CONSTANTS, environment } from 'usermgmt';
import { StationSurveyStepperService } from '../survey-stepper/services/station-survey-stepper.service';
import { RESOURCE_TYPES, USER_ROLES } from '../../constants/proj.cnst';
import { UndoRedoService } from '../../services/layout/undo-redo/undo-redo.service';
import { SHOW_FEATURE } from '../../station-track-visualizer/constants/layout.const';

@Component({
  selector: 'app-sidemenu',
  standalone: true,
  imports: [
    CommonModule,
    RouterModule,
    AvatarModule,
    ButtonModule,
    PanelMenuModule,
    BadgeModule,
    TablerIconComponent,
    TooltipModule,
    ConfirmDialogModule
  ],
    providers: [
    provideTablerIcons({
      IconBuilding,
      IconHome,
      IconLayout2,
      IconKey,
      IconUsers,
      IconBook2,
      IconAppWindow,
      IconFileDiff
    }),
    ConfirmationService
  ],

  templateUrl: './sidemenu.component.html',
  styleUrls: ['./sidemenu.component.scss']
})

export class SidemenuComponent implements OnInit {

  private isBrowser: boolean;
  // Items flagged `nonProdOnly` (e.g. internal/dev tooling) are stripped out
  // entirely when running against the production environment.
  items: MenuItem[] = JSON.parse(JSON.stringify(SIDE_MENU_CONSTANTS.MENU_ITEMS))
    .filter((item: any) => !item.nonProdOnly || !environment.production)
    .filter((item: any) => item.link !== 'export-dwg' || SHOW_FEATURE.KPS_764 === true);
  queryParams: any;
  isCollapsed = false;

  hasResourcesAccess: boolean = false;
  hasNavigated: boolean = false;


  constructor(
    private undoRedoService: UndoRedoService,
    private sidebarService: SidebarService,
    private keycloakService: KeycloakService,
    private appStateSrv: AppStateService,
    private route: ActivatedRoute,
    private router: Router,
    private confirmationService: ConfirmationService,
    private stepperSrv: StationSurveyStepperService,
    @Inject(PLATFORM_ID) private platformId: object
  ) {

    this.isBrowser = isPlatformBrowser(this.platformId);

    this.sidebarService.sidebarState$.subscribe((state) => {
      this.isCollapsed = state;
    });

  }

  ngOnInit() {
    this.subscribeRouterEvents()
  }

  initMethod() {
    if (this.isBrowser) {
      const userPermissionsString: any = localStorage.getItem('userPermissions');


      if (userPermissionsString) {
        const userPermissions = JSON.parse(userPermissionsString);

        if (Object.keys(userPermissions).length > 0) {
          this.hasResourcesAccess = true;
          const hasUMAccess = userPermissions?.[PROJECT_CONSTANTS.USERMGMT_APP_NAME] ?? false;
          if (!hasUMAccess) {
            this.items = this.items.filter((item: any) => item.resourceName !== PROJECT_CONSTANTS.USERMGMT_APP_NAME);
          }

          if (hasUMAccess) {
            const userRole = userPermissions[PROJECT_CONSTANTS.USERMGMT_APP_NAME]?.roleName;

            if (userRole != USER_ROLES.SUPER_ADMIN) {
              this.items = this.items.filter((subItem:any) => subItem.label !== "Organizations");
            }

            

          }

          if (userPermissions && userPermissions[PROJECT_CONSTANTS.APPLICATION_NAME]) {
            const resources = userPermissions[PROJECT_CONSTANTS.APPLICATION_NAME]?.resources;

            if (resources) {
              const resourceArray = Object.values(resources);
              const filteredResources = resourceArray.filter((resource: any) => resource.resourceTypeName === RESOURCE_TYPES.DASHBOARDS);
              this.checkAccessibleDashboardAccess(filteredResources)
            } else {
              // this.router.navigate(['', 'access-denied']);
              console.error("Resources not found for the specified application name.");
            }
          } else {
            this.items = this.items.filter((subItem:any) => subItem.label !== "Home");
            //** Here we are handling the condition where user don't have premission of AP-CRDA */
             this.items.forEach((item : any) => {
                item.disabled = !(item?.resourceName === PROJECT_CONSTANTS.USERMGMT_APP_NAME && hasUMAccess);
             });
            console.error("Invalid userPermissions or application name not found.");
          }
        }
      } else {
        console.error("No userPermissions found in localStorage.");
      }
    }
  }


  checkAccessibleDashboardAccess(availableResources: any) {
    this.items.forEach((sidemenuItem: any) => {
      if (sidemenuItem.resourceTypeName === RESOURCE_TYPES.DASHBOARDS) {
        const hasMatchingResource = availableResources?.some(
          (resource: any) => resource.resourceName === sidemenuItem.resourceName
        );

        if (!hasMatchingResource && sidemenuItem.resourceName !== "Unauthorised Cultivation") {
          sidemenuItem.disabled = true;
        }
      }
    });

    // Geo Portal is disabled
    // if(this.items[0]['disabled'] && !this.hasNavigated) {
    //   this.hasNavigated = true;
    //   this.navigateToRoute(this.items[1]['link'])
    // }
  }


  subscribeRouterEvents() {
    this.route.queryParams.subscribe((params: any) => {
      this.queryParams = params;
      this.initMethod();
    });
    this.router.events.subscribe((routes: any) => {
      this.initMethod();
    });
  }
  toggleItem(item: any): void {
  if (item['items']?.length) {
    item['expanded'] = !item['expanded'];
  }
}




  toggleAll() {
    const expanded: any = !this.areAllItemsExpanded();
    this.items = this.toggleAllRecursive(this.items, expanded);
  }

  private toggleAllRecursive(items: MenuItem[], expanded: boolean): MenuItem[] {
    return items.map((menuItem: any) => {
      menuItem.expanded = expanded;
      if (menuItem.items) {
        menuItem.items = this.toggleAllRecursive(menuItem.items, expanded);
      }
      return menuItem;
    });
  }

  private areAllItemsExpanded(): boolean {
    return this.items.every((menuItem: any) => menuItem.expanded);
  }



  navigateToRoute(route: string) {
    // this.router.navigate([route]);
    this.router.navigate([route]).then(success => {
    }).catch(err => {
      console.error('Navigation error:', err);
    });

  }

  private isOnDraftRoute(): boolean {
    return this.router.url.startsWith('/addStation') && this.router.url.includes('isDraftLoad=true');
  }

  shouldBlockNavigation(item: any): boolean {
    return item.link === 'landing' && this.isOnDraftRoute() && this.stepperSrv.hasUnsavedChanges();
  }

  onMenuItemClick(event: Event, item: any): void {
    this.undoRedoService.clearAll(this.queryParams['station_uuid']);
    if (item.link === 'landing' && this.isOnDraftRoute() && this.stepperSrv.hasUnsavedChanges()) {
      event.preventDefault();
      event.stopPropagation();
      this.confirmationService.confirm({
        header: 'Unsaved Changes',
        message: 'You have unsaved changes. Going back will discard any unsaved progress.',
        icon: 'pi pi-exclamation-triangle',
        acceptLabel: 'Proceed',
        rejectLabel: 'Cancel',
        rejectButtonStyleClass: 'p-button-text',
        accept: () => {
          this.stepperSrv.removeStationDataFromLocalStorage();
          this.stepperSrv.removeSurveyDataFromLocalStorage();
          this.router.navigate(['/landing']);
          this.sidebarService.closeSidebar();
        }
      });
      return;
    }
    if (item.link && !item.items?.length) {
      this.sidebarService.closeSidebar();
    }
  }


  toggleSidebar() {
    this.sidebarService.toggleSidebar();
  }

  logOut() {
    this.keycloakService.logout();
  }
}
